// src/services/vehicleService.js
import apiClient from './apiClient';

const vehicleService = {
  // Agregar un nuevo vehículo
  addVehicle: async (vehicleData) => {
    try {
      console.log('Adding vehicle:', JSON.stringify(vehicleData, null, 2));
      const response = await apiClient.post('/userApp/addVehicle', vehicleData);
      console.log('Vehicle added response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error adding vehicle:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener todos los vehículos de un usuario
  getUserVehicles: async (idCard) => {
    try {
      const response = await apiClient.get(`/userApp/getAllVehiclesById?idCard=${idCard}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting vehicles for user ${idCard}:`, error);
      throw error;
    }
  },

  // Eliminar un vehículo
  deleteVehicle: async (idCard, plate) => {
    try {
      const response = await apiClient.delete(`/userApp/deleteVehicle?idCard=${idCard}&plate=${plate}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting vehicle ${plate}:`, error);
      throw error;
    }
  },

  // Actualizar información de un vehículo
  updateVehicle: async (plate, vehicleData) => {
    try {
      console.log('Updating vehicle:', plate, vehicleData);
      const response = await apiClient.put(`/vehicles/updateVehicle?plate=${plate}`, vehicleData);
      console.log('Vehicle updated response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error updating vehicle ${plate}:`, error);
      throw error;
    }
  },

  // Verificar si una placa existe para un usuario
  checkPlate: async (idCard, plate) => {
    try {
      const response = await apiClient.get(`/userApp/checkPlate?idCard=${idCard}&plate=${plate}`);
      return response.data;
    } catch (error) {
      console.error(`Error checking plate ${plate}:`, error);
      throw error;
    }
  },

  // Obtener todos los vehículos (para administradores)
  getAllVehicles: async () => {
    try {
      const response = await apiClient.get('/userApp/getAllVehicles');
      return response.data;
    } catch (error) {
      console.error('Error getting all vehicles:', error);
      throw error;
    }
  },

  // Carga masiva de vehiculos desde archivo XLSX
  bulkUpload: async (file, options = {}) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (options.brand) formData.append('brand', options.brand);
      if (options.model) formData.append('model', options.model);
      if (options.type) formData.append('type', options.type);
      if (options.company) formData.append('company', options.company);

      const response = await apiClient.post('/vehicles/bulk-upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000, // 5 minutos para carga masiva
      });
      return response.data;
    } catch (error) {
      console.error('Error en carga masiva:', error);
      throw error;
    }
  }
};

export default vehicleService;